import React, { useEffect, useState } from 'react';
import { BarGraph } from '../BarGraph';
import { IBarGraphProps } from '../types';
import { useSelector } from 'react-redux';
import { RootState } from 'app/main/rootReducer';
import { makeStyles, Paper, TablePagination } from '@material-ui/core';
import { InitialBarGraphState, MakeAvgSpendBarGraphProps } from '../helper';

const NS = 'AvgSpendBookingWrapper';

const useStyles = makeStyles({
  containerDiv: {
    width: '500px',
    paddingRight: '5px'
  },
  tableTitle: {
    fontWeight: 'normal',
    margin: '8px 8px 8px 50px'
  },
});

/**
 * Displays the average spend booking size in bar graph with pagination.
 */
export const AvgSpendBookingWrapper = () => {

  const barsPerPage = 10;
  const classes = useStyles();
  const [page, setPage] = useState<number>(0);
  const [rows, setTableRows] = useState<IBarGraphProps>(InitialBarGraphState);
  const { avgPerPaxSpendStats } = useSelector((state: RootState) => state.dashboardReducer);

  useEffect(() => {
    const currentPageAvgPerPaxSpendStats = avgPerPaxSpendStats.slice(page * barsPerPage, (page * barsPerPage) + barsPerPage);
    const dataRows = MakeAvgSpendBarGraphProps(currentPageAvgPerPaxSpendStats);
    setTableRows(dataRows);
  }, [avgPerPaxSpendStats, page]);

  // Navigate to the first page, whenever data is refreshed.
  useEffect(() => setPage(0), [avgPerPaxSpendStats]);

  if (avgPerPaxSpendStats.length === 0) return null;

  return (
    <Paper id="avgSpendWrapper" className={classes.containerDiv}>
      <h2 data-testid="title" className={classes.tableTitle}>Total Spend Per Booking Size</h2>
      <BarGraph {...rows} />
      <TablePagination
        page={page}
        component="div"
        labelRowsPerPage=""
        rowsPerPageOptions={[]}
        rowsPerPage={barsPerPage}
        count={avgPerPaxSpendStats.length}
        onChangePage={(event: unknown, newPage: number) => setPage(newPage)} />
    </Paper>
  )
}